
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import {mapActions, mapGetters, mapState} from 'vuex';
    import EingetragenAmVom from '@/components/EingetragenAmVom.vue';
    import Systemdaten from '@/types/Systemdaten';
    import { Validatable, VCurrencyField, VForm } from '@/types/Components';

    @Component({
        components: {
            EingetragenAmVom,
        },
        computed: {
            ...mapState('globals', ['rules']),
            ...mapState('systemdaten', ['systemdaten', 'loaders']),
            ...mapGetters('authentication', ['getSystemEinstellung']),
        },
        methods: {
            ...mapActions('systemdaten', ['loadSystemdaten', 'updateSystemdaten']),
        },
    })
    export default class SystemdatenDetail extends Vue {
        @Prop() visible!: boolean;
        public textErrorMessage = '';

        public $refs!: {
            form: VForm & { inputs: Validatable[] };
            ust: VCurrencyField;
            befundtext1: Validatable;
            befundtext2: Validatable;
            rk_verzeichnis: Validatable;
            mail_server?: Validatable;
            mail_username?: Validatable;
            mail_password?: Validatable;
            mail_sender?: Validatable;
            termin_text1?: Validatable;
            termin_text2?: Validatable;
            termin_text3?: Validatable;
        };

        public systemdaten!: Systemdaten;
        public loadSystemdaten!: () => void;
        public updateSystemdaten!: (payload: Systemdaten) => void;

        public tabIndex = 'tab-allgemein';
        public defaultUst: number | null = 0;

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                this.tabIndex = 'tab-allgemein';
                this.loadSystemdaten();
            }
        }

        @Watch('loaders.systemdaten')
        public onChangeSystemdaten(loading: boolean): void {
            if (!loading) {
                this.defaultUst = this.systemdaten.ust;
                this.$nextTick(() => this.$refs.ust.setValue(this.defaultUst ?? 0));
            }
        }

        public onClickSave(): void {
            const tabs = {
                'tab-allgemein': [
                    this.$refs.befundtext1,
                    this.$refs.befundtext2,
                    this.$refs.rk_verzeichnis,
                ],
                'tab-email': [
                    this.$refs.mail_server,
                    this.$refs.mail_username,
                    this.$refs.mail_password,
                    this.$refs.mail_sender,
                ],
                'tab-termin': [
                    this.$refs.termin_text1,
                    this.$refs.termin_text2,
                    this.$refs.termin_text3,
                ],
            };

            for (const [tabIndex, refs] of Object.entries(tabs)) {
                if (refs.some((ref) => (ref?.errorBucket?.length ?? 0) > 0)) {
                    this.tabIndex = tabIndex;
                    return;
                }
            }

            this.updateSystemdaten(this.systemdaten);
        }

        public get textLabelClass(): string {
            return this.textErrorMessage === ''
                ? 'primary--text'
                : 'red--text';
        }
    }
